import React from 'react';
import { I18nConsumer } from './i18n';
import I18nErrors from './i18nErrors';

const DEFAULT_PROPS = [
  'interpolator',
  'getUserLanguage',
  'getMessage',
  'formatMessage',
  'formatHTMLMessage',
  'formatNumber',
  'formatDateTime',
  'formatRelative'
];

/**
 * HOC to add i18n Consumer easily
 * @param {node} Component React component to be enhanced
 * @param {object} Options
 * @returns {LocalizedComponent} the React component with the added localization context
 */
export function withLocalization(Component, options = {}) {
  /**
   * I18n Consumer
   */
  function LocalizedComponent(props) {
    let component = (
      <I18nConsumer displayName={`I18nConsumer(${Component.name})`}>
        {context => {
          const propsList = options.propsList || DEFAULT_PROPS;
          const localizationProps = propsList.reduce((obj, item) => (
            {
              ...obj,
              [item]:context[item]
            }), {});
          return <Component
            locale={context.locale}
            localeData={context.mergeLocaleData(props.localeData)}
            {...props}
            {...localizationProps}
          />;
        }}
      </I18nConsumer>
    );

    if (options.withErrorBoundary) {
      return (
        <I18nErrors displayName={`I18nErrors(${Component.name})`}>
          {component}
        </I18nErrors>
      );
    }

    return component;
  }

  if (options.displayName) {
    LocalizedComponent.displayName = `withLocalization(${options.displayName})`;
  }
  LocalizedComponent.WrappedComponent = Component;

  return LocalizedComponent;
}
